
import '../../assets/css/productshoting.css';
import { Button } from "react-bootstrap";

const ProductShorting = () => {
    return (
        <>
            {/* <select
                className="Form-Control input-control-form"
                style={{
                    fontSize: "14px",
                    width: "230px",
                    marginRight: "10px",
                    marginLeft: "5px"
                }}
            >
                <option value="Asc">Sort by : Price - Low To High</option>
                <option value="Desc">Price - High to Low</option>
                <option value="new-arrival">New Arrival</option>
            </select> */}

            <Button className="button-btn mr-1">
                <i className="bi bi-sort-down-alt"></i> Sort
            </Button>
        </>
    );
};

export default ProductShorting;
